import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {ZahlungDTO} from '../../openapi/zahlung-openapi';

export const zahlungEntitiesAdapter: EntityAdapter<ZahlungDTO> = createEntityAdapter<ZahlungDTO>();
